import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import { connect } from 'react-redux';
//import find from 'array.prototype.find';
//import { Prompt } from 'react-router-dom';
//import {errorValidataion,toggleSizeButton} from '../actions/sessions';
//import Toast from 'grommet/components/Toast';
import Article from 'grommet/components/Article';
import Heading from 'grommet/components/Heading';
import Paragraph from 'grommet/components/Paragraph';
import CheckBox from 'grommet/components/CheckBox';
import FormField from 'grommet/components/FormField';
import TextInput from 'grommet/components/TextInput';
import TableRow from 'grommet/components/TableRow';
import Select from 'grommet/components/Select';
import CircleInformation from 'grommet/components/icons/base/CircleInformation';
//import GetAllSupportedComponents from '../../Datafiles/GetAllSupportedComponents.json';
import Tabs from 'grommet/components/Tabs';
import Tab from 'grommet/components/Tab';
import Layer from 'grommet/components/Layer';
import CloseIcon from 'grommet/components/icons/base/FormClose';
import TrashIcon from 'grommet/components/icons/base/Trash';
import Spinning from 'grommet/components/icons/Spinning';
//import { fetchFilteredComps } from '../Redux/actions/epaActions';
import { toggleSizeButton } from '../../State/actions/sessions';
import ReactTooltip from 'react-tooltip';
//import Layer from 'grommet/components/Layer';
import { defaultfetchServerList, fetchSupportedList, getosdisklist } from '../Redux/actions/epaActions';
import {updateGrowthItem,removeObject, serverChangeCompatibilityCheck} from '../commonLogic';
import DataDrive from './DataDrive.js';
import * as Constants from '../Redux/action_types/EPAConstants.js';
//import dataDriveOptions from '../../Datafiles/DataDrive.js';

let GatewayserverValue, GatewayprocessorValue, GatewayprocessorTypeValue, GatewaypocQtyValue, GatewaydatadisktypValue, GatewayosdisktypValue, GatewayDiskQtyvalue, GatewayOSDiskQtyvalue, GatewaymemoryValue
let EdgeserverValue, EdgeprocessorValue, EdgepocQtyValue, EdgedatadisktypValue, EdgeosdisktypValue, EdgenodeDiskQtyvalue, EdgememoryValue
let HeadserverValue, HeadprocessorValue, HeadprocessorTypeValue, HeadpocQtyValue, HeaddatadisktypValue, HeadosdisktypValue, HeadnodesQtyValue, HeadnodesOSDisksQtyValue, HeadmemoryValue, GatewayNodeQtyValue, EdgeNodeQtyValue
let GatewayServers = []
let GatewayDrives = []
let GatewayMemoryList = []
let GatewayOSDiskList = []
let GatewayProcList = []
let GatewayProcFamilyList = []

//let EdgeServers = []
//let EdgeDrives = []
//let EdgeOSDiskList = []
//let EdgeMemoryList = []
//let EdgeProcList = []

let HeadServers = []
let HeadDrives = []
let HeadMemoryList = []
let HeadOSDiskList = []
let HeadProcList = []
let HeadProcFamilyList = []
let GatewaySizerNodeQtyValue
let MasterNodeQtyValue, MasternodesQtyValue
//let GateNodeDatadiskqtynotchange = true
let GateNodeOSdiskqtynotchange = true
//let HeadDatadiskqtynotchange = true
let HeadOSdiskqtynotchange = true
let GateNodeMaxDriveQty = ""
let HeadNodeMaxDriveQty = " "
let maxlayer = false
let maxDrivevalue = ""
let functionnode = ""
let MasterdefaultNodevalue = ''
let GatewaydefaultNodevalue = ''
let NodeQtyvisible = ''
let GatewayNodeQtyvisible = ''
let MasterChecked = false
let GatewayChecked = false
let gatewayDataDriveType = '';
let masterNodeDataDriveType = ''
let editExisting = false;
let isMixedStorageConfigurationgateWay = "False"
let isMixedStorageConfigurationmasterNode = "False"
let gatewayDataDriveConsolidatedOptions = []
let masterNodeDataDriveConsolidatedOptions = []
let serverChangeConfirmationlayer = ""

class HadoopServices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      NodeQtyvisible: true,
      activeIndex: 0,
      changeDriveTypeOptions : false
    };
    this.maxDriveCountValidation = this.maxDriveCountValidation.bind(this)
    this.layerclose = this.layerclose.bind(this);
  }

  componentWillMount() {
    if(this.props.workload !== undefined) {
    if (this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Gateway Node")[0].Service !== undefined) { 
      if(!(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Gateway Node")[0].Service.DataDisks))) {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Gateway Node")[0].Service["@mixedStorage"] = "False";
      }
    }
    if(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Master Node")[0].Service !== undefined) {
      if(!(Array.isArray(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Master Node")[0].Service.DataDisks))) {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Master Node")[0].Service["@mixedStorage"] = "False";
      }
    }
  }
  }
  componentDidMount() {
    if (this.props.defaultSizerWorkload !== undefined && this.props.defaultSizerWorkload !== null) {

      let Input = {
        "Workload": null,
      }

      Input.Workload = this.props.workload;

      var Inputs = {
        DefaultData: [
          {
            "function": "Gateway Node",
            "service": "",
            "workload": Input
          },
          {
            "function": "Master Node",
            "service": "",
            "workload": Input
          },
          {
            "PricingRegion": this.props.workload.UserInputs.Country
          }
        ]
      }


      var pushservice = true
      // this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      //   if (ServiceName.functionName === 'Gateway Node' || ServiceName.functionName === 'Master Node') {
      //     pushservice = false;
      //   }
      // });
      if (pushservice) {
        this.props.OnDefaultFetchServerList(Inputs);
      }

    }


    if (!this.props.activeSession.isSizeEnabled)
      this.props.OnToggleSizeButton(true);

    var index = this.props.defaultSizerWorkload.Indexes.extraConfiguration;
    this.setState({ activeIndex: index })

  }

  populateDataDriveoptions = (service) => {
    let drivesArray = []
    let temp = []
    let existingDriveTypes = []
    let server = this.state.activeIndex === 0 ? HeadserverValue : GatewayserverValue;
    this.props.defaultSizerWorkload.serversList.filter(x=>x['functionName'] === service)[0].totalList[server].DataDiskList.map(x=>{

          drivesArray.push(x)

    })
    let noOfExistingDataDisks = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks.length
    let isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service["@mixedStorage"]
    if (noOfExistingDataDisks > 0 && isMixedStorageConfiguration === "True") {
      let existingDrives = [] 
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks.map(x=>{
        existingDrives.push(x.Item["@disk"])
      })
      this.props.defaultSizerWorkload.serversList.filter(x=>x['functionName'] === service)[0].totalList[server].DataDiskList.filter(x =>{
          if(existingDrives.indexOf(x.StrDrive) !== -1 ) {
          x.Types.map(y=>{
            if(existingDriveTypes.indexOf(y) === -1) {
              existingDriveTypes.push(y)
            }
          })
          }
      })

      if (existingDriveTypes.indexOf('LFF HDD') !== -1 || existingDriveTypes.indexOf('LFF SSD') !== -1) {
        drivesArray.map(x => {
          if (x.Types.indexOf('SFF HDD') === -1 && x.Types.indexOf('SFF SSD') === -1 ) {
            temp.push(x)
          }
        })
      } else if (existingDriveTypes.indexOf('SFF HDD') !== -1 || existingDriveTypes.indexOf('SFF SSD') !== -1) {
        drivesArray.map(x => {
          if (x.Types.indexOf('LFF HDD') === -1 && x.Types.indexOf('LFF SSD') === -1) {
            temp.push(x)
          }
        })
      }
      else {
        drivesArray.map(x => {
            temp.push(x)
        })
      }
      drivesArray = [];
      drivesArray = temp;
      temp = [];
      if (existingDriveTypes.indexOf('SFF SAS SSD') !== -1 || existingDriveTypes.indexOf('SFF SAS HDD') !== -1 || existingDriveTypes.indexOf('LFF SAS SSD') !== -1 || existingDriveTypes.indexOf('LFF SAS HDD') !== -1 || existingDriveTypes.indexOf('NVMe') !== -1 ) {
        drivesArray.map(x => {
          if (x.Types.indexOf('LFF SATA HDD') === -1 && x.Types.indexOf('SFF SATA HDD') === -1) {
            temp.push(x);
          }
        })
      } else if (existingDriveTypes.indexOf('SFF SATA HDD') !== -1 || existingDriveTypes.indexOf('LFF SATA HDD') !== -1 ) {
        drivesArray.map(x => {
          if (x.Types.indexOf('SFF SAS SSD') === -1 && x.Types.indexOf('SFF SAS HDD') === -1 && x.Types.indexOf('LFF SAS SSD') === -1 && x.Types.indexOf('LFF SAS HDD') === -1 && x.Types.indexOf('NVMe') === -1) {
            temp.push(x);
          }
        })
      } else {
        drivesArray.map(x => {
          temp.push(x)
      })
      }
      drivesArray = [];
      drivesArray = temp;
      temp = [];
    }
    if( service === "Gateway Node") {
      GatewayDrives = []
      drivesArray.map(x=>{
        if(x.Types.indexOf(gatewayDataDriveType)!==-1){
          GatewayDrives.push(x.StrDrive)
        }
      })
      if( gatewayDataDriveConsolidatedOptions.length === 0 || this.state.changeDriveTypeOptions) {
      this.state.changeDriveTypeOptions = false;
      gatewayDataDriveConsolidatedOptions = []
      drivesArray.map(x => {
        x.Types.map(y => {
          if (gatewayDataDriveConsolidatedOptions.indexOf(y) === -1) {
            gatewayDataDriveConsolidatedOptions.push(y)
          }
        })
      })
    }
    } else {
      HeadDrives = []
      drivesArray.map(x=>{
        if(x.Types.indexOf(masterNodeDataDriveType)!==-1){
          HeadDrives.push(x.StrDrive)
        }
      })
      if( masterNodeDataDriveConsolidatedOptions.length === 0 || this.state.changeDriveTypeOptions) {
        this.state.changeDriveTypeOptions = false;
      masterNodeDataDriveConsolidatedOptions = []
      drivesArray.map(x => {
        x.Types.map(y => {
          if (masterNodeDataDriveConsolidatedOptions.indexOf(y) === -1) {
            masterNodeDataDriveConsolidatedOptions.push(y)
          }
        })
      })
    }
    }
  }

  onAddingDataDisk = () => {
    let service = this.state.activeIndex === 0 ? "Master Node" : "Gateway Node";
    if (this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware["@DiskQty"] != "0" && this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware["@DataDisk"] !== undefined) {
      let diskNumber = ""
      let Hardware = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware
      let isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service["@mixedStorage"]
      this.maxDriveCountValidation(service)
      if(!maxlayer) {
      if(isMixedStorageConfiguration !== "True") {
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks = []  
      }
      if(service === "Gateway Node" ) {
        isMixedStorageConfigurationgateWay = "True"
      } else {
        isMixedStorageConfigurationmasterNode = "True"
      }
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service["@mixedStorage"] = "True"
      let existingDrivesArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks
      diskNumber = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks.length
        let pushDrive = true
        if (diskNumber > 0 ) {
          existingDrivesArray.map(x => {
            if (x.Item["@disk"] === this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware["@DataDisk"]) {
              x.Item["@qty"] = (parseInt(x.Item["@qty"], 10) + parseInt(this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware["@DiskQty"], 10)).toString()
              pushDrive = false
            }
          })
        }
        if (pushDrive) { 
        let newDrive = {Item : {
          "@disk" : Hardware["@DataDisk"] ,
          "@qty": Hardware["@DiskQty"],
          "@volumeName": "Data_"+ diskNumber
        }}
        this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks.push(newDrive);
      }
      this.state.changeDriveTypeOptions = true;
      this.populateDataDriveoptions(service);
    }
    if (service === "Gateway Node") {
      GatewayDiskQtyvalue = this.noOfDrivesleft(service, "");
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware["@DiskQty"] = GatewayDiskQtyvalue
    } else {
      HeadnodesQtyValue = this.noOfDrivesleft(service, "");
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware["@DiskQty"] = HeadnodesQtyValue
    }
      this.setState({})
    }
  }

  deleteDrive = (id, service) => {
    this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks.splice(id,1);
    if (this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks.length == 0) {
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service["@mixedStorage"] = "False"
      if(service === "Gateway Node" ) {
        isMixedStorageConfigurationgateWay = "False"
      } else {
        isMixedStorageConfigurationmasterNode = "False"
      }
    }
    this.state.changeDriveTypeOptions = true;
    this.populateDataDriveoptions(service);
    if (service === "Gateway Node") {
      GatewayDiskQtyvalue = this.noOfDrivesleft(service, "");
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware["@DiskQty"] = GatewayDiskQtyvalue
    } else {
      HeadnodesQtyValue = this.noOfDrivesleft(service, "");
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware["@DiskQty"] = HeadnodesQtyValue
    }
    this.setState({})
  }
  
  renderTable = () => {
    let service = this.state.activeIndex === 0 ? "Master Node" :  "Gateway Node";
    let tableData = [];
    let tableDataArray = ""
    tableDataArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks
    
    tableDataArray.map(((dataDrive, id)=>{
      tableData.push(
          <TableRow>
            <td>{dataDrive.Item["@disk"]}</td>
            <td><TextInput value={dataDrive.Item["@qty"]} onDOMChange={(e)=>this.onNoOfDisksChange(e, service, "", "Change", true, id)} onBlur={(e)=>this.onNoOfDisksChange(e, service, "", "Blur", true, id)}/></td>
            <td><TrashIcon  primary={true} onClick={()=>this.deleteDrive(id, service)}/></td>
          </TableRow>
      )
    }))
    return tableData; 
  }

  noOfDrivesleft = (node, driveID) => {
    let maxDrives = ""
    let maxDrivesLeft = ''
    let server = this.state.activeIndex === 0 ? HeadserverValue : GatewayserverValue;
    let currentDrive = this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === node)[0].Service.Hardware["@DataDisk"];
    maxDrives = this.props.defaultSizerWorkload.serversList.filter(service=>service.functionName === node)[0].totalList[server].iDataDiskQty
    let DataDisksArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.DataDisks
    if (editExisting && driveID !== "") {
      currentDrive = DataDisksArray[driveID].Item["@disk"];
    }
    if (currentDrive.toUpperCase().indexOf(Constants.NVME_) > -1) {
      maxDrives = this.props.defaultSizerWorkload.serversList.filter(service=>service.functionName === node)[0].totalList[server].iMaxNVMeDrives;
      let noOfExistingNVMeDrives = 0
      if (DataDisksArray.length > 0 && this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service["@mixedStorage"] === Constants.TRUE_) {
        DataDisksArray.map((x, id) => {
          if (x.Item["@disk"].toUpperCase().indexOf(Constants.NVME_) > -1) {
            if (!(editExisting && id === driveID)) {
              noOfExistingNVMeDrives += parseInt(x.Item["@qty"], 10);
            }
          }
        })
      }
      maxDrivesLeft = maxDrives - noOfExistingNVMeDrives;
    } else {
      let noOfExistingDrives = 0
      if (DataDisksArray.length > 0 && this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service["@mixedStorage"] === Constants.TRUE_) {
        DataDisksArray.map((x, id) => {
          if (!(editExisting && id === driveID)) {
            noOfExistingDrives += parseInt(x.Item["@qty"], 10)
          }
        })
      }
      maxDrivesLeft = maxDrives - noOfExistingDrives;
    }
    return maxDrivesLeft;
  }
  ongatewayDataDriveTypeChange = (e) => {
    gatewayDataDriveType = e.option;
    this.populateDataDriveoptions("Gateway Node")
    if (GatewayDrives.indexOf(GatewaydatadisktypValue) === -1 ) {
      GatewaydatadisktypValue = GatewayDrives[0];
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Gateway Node")[0].Service.Hardware["@DataDisk"] = GatewaydatadisktypValue
    }
    GatewayDiskQtyvalue = this.noOfDrivesleft("Gateway Node", "");
    this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Gateway Node")[0].Service.Hardware["@DiskQty"] = GatewayDiskQtyvalue
    this.setState({});
  }

  onMasterNodeDataDriveTypeChange = (e) => {
    masterNodeDataDriveType = e.option;
    this.populateDataDriveoptions("Master Node")
    if (HeadDrives.indexOf(HeaddatadisktypValue) === -1 ) {
      HeaddatadisktypValue = HeadDrives[0];
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Master Node")[0].Service.Hardware["@DataDisk"] = HeaddatadisktypValue
    }
    HeadnodesQtyValue = this.noOfDrivesleft("Master Node", "");
    this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === "Master Node")[0].Service.Hardware["@DiskQty"] = HeadnodesQtyValue
    this.setState({});
  }

  layerclose(e, node) {
    maxlayer = false;
    this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      switch (node) {
        case "Gateway Node":
          if (ServiceName.functionName === "Gateway Node") {
            for (let key in ServiceName.totalList) {
              if (key === GatewayserverValue) {
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                  if (val['@Type'] === "Gateway Node") {
                    // GatewayDiskQtyvalue = ServiceName.totalList[key].iDataDiskQty.toString();
                    // val.Service.Hardware['@DiskQty'] = GatewayDiskQtyvalue
                    GatewayOSDiskQtyvalue = ServiceName.totalList[key].iOSDiskQty.toString();
                    val.Service.Hardware['@OSDiskQty'] = GatewayOSDiskQtyvalue
                  }
                })
                // GateNodeMaxDriveQty=ServiceName.totalList[key].iMaxDrives
              }
            }
          }
          break;

        case "Master Node":
          if (ServiceName.functionName === "Master Node") {
            for (let key in ServiceName.totalList) {
              if (key === HeadserverValue) {
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                  if (val['@Type'] === "Master Node") {
                    // HeadnodesQtyValue = ServiceName.totalList[key].iDataDiskQty.toString();
                    // val.Service.Hardware['@DiskQty'] = HeadnodesQtyValue
                    HeadnodesOSDisksQtyValue = ServiceName.totalList[key].iOSDiskQty.toString();
                    val.Service.Hardware['@OSDiskQty'] = HeadnodesOSDisksQtyValue
                  }
                })
              }
            }
          }
          break;
      }
    })
    this.setState({})
  }
  maxDriveCountValidation(e) {
    let noOfExistingNVMeDrives = 0
    let noOfExistingDrives = 0
    let qtyOfExistingDataDisks = 0
    let noOfExistingNonNVMeDrives = 0;
    let FunctionName = e;
    let MaxDriveQty = 0;
    let OSDiskQtyvalue = 0;
    let DataDiskQtyvalue = 0;
    let serverValue;
    this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
      if (ServiceName.functionName === FunctionName) {
        for (var key in ServiceName.totalList) {
          serverValue = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === FunctionName)[0].Service.Hardware["@Server"];
          if (key === serverValue) {
            OSDiskQtyvalue = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === FunctionName)[0].Service.Hardware["@OSDiskQty"];
            DataDiskQtyvalue = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === FunctionName)[0].Service.Hardware["@DiskQty"];
            MaxDriveQty = ServiceName.totalList[key].iMaxDrives
            let dataDisksArray = []
            dataDisksArray = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === FunctionName)[0].Service.DataDisks;
            if (this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === FunctionName)[0].Service.Hardware["@DataDisk"].toUpperCase().indexOf(Constants.NVME_) > -1) {
              MaxDriveQty = ServiceName.totalList[key].iMaxNVMeDrives
              if (dataDisksArray.length > 0 && this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === FunctionName)[0].Service["@mixedStorage"] === Constants.TRUE_) {
                dataDisksArray.map(x => {
                  if (x.Item["@disk"].toUpperCase().indexOf(Constants.NVME_) !== -1) {
                    noOfExistingNVMeDrives += parseInt(x.Item["@qty"], 10)
                  } else {
                    noOfExistingNonNVMeDrives += parseInt(x.Item["@qty"], 10);
                  }
                })
              }
              if (this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === FunctionName)[0].Service.Hardware["@OSDisk"].toUpperCase().indexOf(Constants.NVME_) !== -1) {
                noOfExistingNVMeDrives += parseInt(this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === FunctionName)[0].Service.Hardware["@OSDiskQty"], 10)
              } else {
                noOfExistingNonNVMeDrives += parseInt(this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === FunctionName)[0].Service.Hardware["@OSDiskQty"], 10);
              }
              if (editExisting) {
                qtyOfExistingDataDisks = noOfExistingNVMeDrives
              } else {
                qtyOfExistingDataDisks = noOfExistingNVMeDrives + parseInt(DataDiskQtyvalue, 10)
              }
              if (qtyOfExistingDataDisks <= MaxDriveQty) {
                MaxDriveQty = ServiceName.totalList[key].iMaxDrives
                if (editExisting) {
                  qtyOfExistingDataDisks = noOfExistingNVMeDrives + noOfExistingNonNVMeDrives;
                } else {
                  qtyOfExistingDataDisks = noOfExistingNVMeDrives + noOfExistingNonNVMeDrives + parseInt(DataDiskQtyvalue, 10);
                }
              }
            } else {
              if (dataDisksArray.length > 0 && this.props.workload.UserInputs.Environments.Functions.Function.filter(x => x["@Type"] === FunctionName)[0].Service["@mixedStorage"] === Constants.TRUE_) {
                dataDisksArray.map(x => {
                  noOfExistingDrives += parseInt(x.Item["@qty"], 10);
                })
              }
              if (editExisting) {
                qtyOfExistingDataDisks = noOfExistingDrives + parseInt(OSDiskQtyvalue, 10)
              } else {
                qtyOfExistingDataDisks = noOfExistingDrives + parseInt(DataDiskQtyvalue, 10) + parseInt(OSDiskQtyvalue, 10)
              }
            }
            
            if (MaxDriveQty < qtyOfExistingDataDisks) {
              maxDrivevalue = MaxDriveQty
              maxlayer = true;
              functionnode = FunctionName
            } else {
              maxlayer = false;
            }
          }
        }
      }
    })
  }
  onMasterNodevalueChange(e) {
    //MasternodesQtyValue=e.target.value;
    //nodesQtyValue=e.target.value;
    var number = /^[0-9]+$/
    if (e.target.value.length < 6) {
      var value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        MasternodesQtyValue = ""
      }
      else if ((number.test(value)) && (value <= 99999) && (value >= 1) || isNaN(value)) {
        MasternodesQtyValue = value.toString();

      }
      else {

      }
    }
    this.onWorkloadUpdate();
  }
  onGatewayNodevalueChange(e) {
    var number = /^[0-9]+$/
    if (e.target.value.length < 6) {
      var value = parseInt(e.target.value, 10);
      if (isNaN(value)) {
        GatewayNodeQtyValue = ""
      }
      else if ((number.test(value)) && (value <= 99999) && (value >= 1) || isNaN(value)) {
        GatewayNodeQtyValue = value.toString();

      }
      else {

      }
    }
    this.onWorkloadUpdate();
  }

  onMasterNodevalueBlur(e) {
    if (e.target.value === " " || e.target.value < MasterdefaultNodevalue) {
      MasternodesQtyValue = MasterdefaultNodevalue;
    }

    updateGrowthItem('Master Node',MasternodesQtyValue,this.props.defaultSizerWorkload.workload);

    this.onWorkloadUpdate();
  }
  onGatewayNodevalueBlur(e) {

    if (e.target.value === " " || parseInt(e.target.value, 10) < parseInt(GatewaydefaultNodevalue, 10)) {
      GatewayNodeQtyValue = GatewaydefaultNodevalue;
    }
    updateGrowthItem('Gateway Node',GatewayNodeQtyValue,this.props.defaultSizerWorkload.workload);
    
    this.onWorkloadUpdate();
  }
  onMasterNodeQtyValueChange(e) {
    MasterNodeQtyValue = e.value;
    let visible = false;
    if (e.value === "Sizer Recommendation") {
      visible = true;
      updateGrowthItem('Master Node',MasterdefaultNodevalue,this.props.defaultSizerWorkload.workload);
    }
    NodeQtyvisible = visible;
    this.onWorkloadUpdate();
  }
  onGatewayNodeQtyValueChange(e) {
    GatewaySizerNodeQtyValue = e.value;
    let visible = false;
    if (e.value === "Sizer Recommendation") {
      visible = true;
      GatewayNodeQtyValue = GatewaydefaultNodevalue
      updateGrowthItem('Gateway Node',GatewayNodeQtyValue,this.props.defaultSizerWorkload.workload);
    }
    else {
      GatewayNodeQtyValue = "1"
    }
    GatewayNodeQtyvisible = visible;
    this.onWorkloadUpdate();
  }

  onServerChange(e, node) {
    let validateServerChangeResponse = [true, ''];
    let MixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service["@mixedStorage"];
    if ( MixedStorageConfiguration === "True") {
      validateServerChangeResponse = serverChangeCompatibilityCheck(this.props.workload, e.value, this.props.defaultSizerWorkload.serversList, node, "");
    }
    if(!validateServerChangeResponse[0]) {
      let closeLayer = () => {
        serverChangeConfirmationlayer = "" ;
        this.setState({})
      }
      serverChangeConfirmationlayer = <Layer style={{ zIndex: '500 !important' }}>
      <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
        <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
          <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Warning</Heading>
        </Box>
        <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={() => closeLayer()} >
          <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
        </Box>
      </Box>
      <Box style={{ padding: "10px" }}>
        <Paragraph>{validateServerChangeResponse[1]}</Paragraph>
      </Box>
    </Layer>
      this.setState({})
    }else {
    this.state.changeDriveTypeOptions = true;
    if (MixedStorageConfiguration !== Constants.TRUE_) {
      if ( node === "Master Node") {
        isMixedStorageConfigurationmasterNode = "False"
        masterNodeDataDriveType = ""
        masterNodeDataDriveConsolidatedOptions = []
      } else {
        gatewayDataDriveType = '';
        isMixedStorageConfigurationgateWay = "False"
        gatewayDataDriveConsolidatedOptions = []
      }
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service["@mixedStorage"] = "False"
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.DataDisks = []
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.Hardware["@dataDriveType"] = "";
    }
    let processorQuantity = "2";
    if (e.value === Constants.PROLIANT_DL325_GEN10_PLUS) {
      processorQuantity = "1"
    }
    var OSInputs = {};
    switch (node) {
      case "Gateway Node":
        GatewayserverValue = e.value;
        GatewaypocQtyValue = processorQuantity;
        OSInputs = {
          "strFunction": "Gateway Node",
          "strService": "",
          "strServer": GatewayserverValue,
          "strDataDisk": GatewaydatadisktypValue,
        }
        this.props.OnGetOSDiskList(OSInputs);
        break;
      case "Edge Node":
        EdgeserverValue = e.value;
        break;
      case "Master Node":
        HeadserverValue = e.value;
        HeadpocQtyValue = processorQuantity;
        OSInputs = {
          "strFunction": "Master Node",
          "strService": "",
          "strServer": HeadserverValue,
          "strDataDisk": HeaddatadisktypValue,
        }
        this.props.OnGetOSDiskList(OSInputs);
        break;
    }


    if (this.props.defaultSizerWorkload.serversList !== "" && this.props.defaultSizerWorkload.serversList !== undefined && this.props.defaultSizerWorkload.serversList !== null) {
      this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
        if (ServiceName.functionName === node) {
          switch (ServiceName.functionName) {
            case "Gateway Node":
              for (let key in ServiceName.totalList) {
                if (key === GatewayserverValue) {
                  GatewayProcList = []
                  GatewayProcFamilyList = []
                  GatewayDrives = ServiceName.totalList[key].DataDiskList
                  if (MixedStorageConfiguration !== Constants.TRUE_) {
                    GatewayDiskQtyvalue = ServiceName.totalList[key].iDataDiskQty
                  } else {
                    GatewayDiskQtyvalue = this.noOfDrivesleft(node, "");
                  }
                  GatewayOSDiskList = ServiceName.totalList[key].OSDiskList
                  for (let proctype in ServiceName.totalList[key].ProcessorList) {
                    if (GatewayProcFamilyList.indexOf(proctype) === -1) {
                      GatewayProcFamilyList.push(proctype);
                    }
                  }
                  if (GatewayProcFamilyList.indexOf(GatewayprocessorTypeValue) === -1) {
                    GatewayprocessorTypeValue = GatewayProcFamilyList[0];
                  }
                  for (let proctype in ServiceName.totalList[key].ProcessorList) {
                    if (proctype === GatewayprocessorTypeValue) {
                      for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                        if (GatewayProcList.indexOf(proc) === -1) {
                          GatewayProcList.push(proc);
                        }
                      }
                      if (GatewayProcList.indexOf(GatewayprocessorValue) === -1) {
                        GatewayprocessorValue = GatewayProcList[0];
                      }

                      //if (proc === GatewayprocessorValue) {
                      //  GatewayMemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                      GatewayMemoryList = ServiceName.totalList[key].ProcessorList[proctype][GatewayprocessorValue]
                      if (GatewayserverValue === "Synergy 480 Gen10 Server" && GatewayprocessorValue.indexOf("M") !== 4 && GatewayprocessorValue.indexOf("L") !== 4 && GatewayMemoryList.indexOf("3072 GB") !== -1) {
                        GatewayMemoryList.pop();
                      }

                      // }
                      //  }

                    }
                  }

                }

              }
              if (GatewayProcFamilyList.indexOf(GatewayprocessorTypeValue) === -1) {
                GatewayprocessorTypeValue = GatewayProcFamilyList[0];
              }
              if (GatewayProcList.indexOf(GatewayprocessorValue) === -1) {
                GatewayprocessorValue = GatewayProcList[0];
              }
              if (GatewayDrives.indexOf(GatewaydatadisktypValue) === -1) {
                GatewaydatadisktypValue = GatewayDrives[0];
              }
              if (GatewayOSDiskList.length > 0 && GatewayOSDiskList.indexOf(GatewayosdisktypValue) === -1) {
                GatewayosdisktypValue = GatewayOSDiskList[0];
              }
              // GatewaydatadisktypValue = GatewayDrives[0];
              // GatewayosdisktypValue = GatewayOSDiskList[0];
              // GatewaymemoryValue = GatewayMemoryList[0];
              break;
            // case "Edge Node":
            //   for (let key in ServiceName.totalList) {
            //     if (key === EdgeserverValue) {
            //       EdgeDrives = ServiceName.totalList[key].DataDiskList
            //       EdgeMemoryList = ServiceName.totalList[key].MemoryList
            //       EdgeOSDiskList = ServiceName.totalList[key].OSDiskList
            //       EdgeProcList = ServiceName.totalList[key].ProcList
            //     }
            //     EdgeprocessorValue = EdgeProcList[0];
            //     EdgedatadisktypValue = EdgeDrives[0];
            //     EdgeosdisktypValue = EdgeOSDiskList[0];
            //     EdgememoryValue = EdgeMemoryList[0];
            //   }
            //   break;
            case "Master Node":
              for (let key in ServiceName.totalList) {
                if (key === HeadserverValue) {
                  HeadProcList = []
                  HeadProcFamilyList = []
                  HeadDrives = ServiceName.totalList[key].DataDiskList
                  if (MixedStorageConfiguration !== Constants.TRUE_) {
                    HeadnodesQtyValue = ServiceName.totalList[key].iDataDiskQty;
                  } else {
                    HeadnodesQtyValue = this.noOfDrivesleft(node, "");
                  }
                  HeadOSDiskList = ServiceName.totalList[key].OSDiskList
                  for (let proctype in ServiceName.totalList[key].ProcessorList) {
                    if (HeadProcFamilyList.indexOf(proctype) === -1) {
                      HeadProcFamilyList.push(proctype);
                    }
                  }
                  if (HeadProcFamilyList.indexOf(HeadprocessorTypeValue) === -1) {
                    HeadprocessorTypeValue = HeadProcFamilyList[0];
                  }
                  for (let proctype in ServiceName.totalList[key].ProcessorList) {
                    if (proctype === HeadprocessorTypeValue) {
                      let proc;
                      for (proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                        if (HeadProcList.indexOf(proc) === -1) {
                          HeadProcList.push(proc);
                        }
                      }

                      if (HeadProcList.indexOf(HeadprocessorValue) === -1) {
                        HeadprocessorValue = HeadProcList[0];
                      }
                      // if (proc === HeadprocessorValue) {
                      HeadMemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                      HeadMemoryList = ServiceName.totalList[key].ProcessorList[proctype][HeadprocessorValue]
                      if (HeadserverValue === "Synergy 480 Gen10 Server" && HeadprocessorValue.indexOf("M") !== 4 && HeadprocessorValue.indexOf("L") !== 4 && HeadMemoryList.indexOf("3072 GB") !== -1) {
                        HeadMemoryList.pop();
                      }
                      //}
                      // }
                    }
                  }
                }
                //  HeadprocessorValue = HeadProcList[0]
                if (HeadDrives.indexOf(HeaddatadisktypValue) === -1) {
                  HeaddatadisktypValue = HeadDrives[0];
                }
                if (HeadOSDiskList.length > 0 && HeadOSDiskList.indexOf(HeadosdisktypValue) === -1) {
                  HeadosdisktypValue = HeadOSDiskList[0];
                }
                if (HeadMemoryList.length > 0 &&  HeadMemoryList.indexOf(HeadmemoryValue) === -1) {
                  HeadmemoryValue = HeadMemoryList[0];
                }
                // HeaddatadisktypValue = HeadDrives[0]
                // HeadosdisktypValue = HeadOSDiskList[0]
                // HeadmemoryValue = HeadMemoryList[0]
              }
              break;
          }

        }
      })
    }

    this.onWorkloadUpdate();
  }
  }
  onOSDiskChange(e, node) {
    switch (node) {
      case "Gateway Node":
        GatewayosdisktypValue = e.value;
        break;
      case "Edge Node":
        EdgeosdisktypValue = e.value;
        break;
      case "Master Node":
        HeadosdisktypValue = e.value;
        break;
    }
    this.onWorkloadUpdate();
    if (node === "Gateway Node") {
      GatewayDiskQtyvalue = this.noOfDrivesleft(node, "");
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.Hardware["@DiskQty"] = GatewayDiskQtyvalue
    } else {
      HeadnodesQtyValue = this.noOfDrivesleft(node, "");
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.Hardware["@DiskQty"] = HeadnodesQtyValue
    }
  }
  onProcessorChange(e, node) {
    switch (node) {
      case "Gateway Node":
        GatewayprocessorValue = e.value;
        break;
      case "Edge Node":
        EdgeprocessorValue = e.value;
        break;
      case "Master Node":
        HeadprocessorValue = e.value;
        break;
    }
    this.onWorkloadUpdate();
  }
  onProcessorFamilytypeChange(e, node) {
    switch (node) {
      case "Gateway Node":
        GatewayprocessorTypeValue = e.value;
        GatewayProcList = []
        this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
          if (ServiceName.functionName === node) {
            for (let key in ServiceName.totalList) {
              if (key === HeadserverValue) {
                GatewayProcList = []
                for (let proctype in ServiceName.totalList[key].ProcessorList) {
                  if (proctype === GatewayprocessorTypeValue) {
                    for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                      if (GatewayProcList.indexOf(proc) === -1) {
                        GatewayProcList.push(proc);
                      }
                      GatewayprocessorValue = GatewayProcList[0];
                      if (proc === GatewayprocessorValue) {
                        GatewayMemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                         if (GatewayserverValue === "Synergy 480 Gen10 Server" && GatewayprocessorValue.indexOf("M") !== 4 && GatewayprocessorValue.indexOf("L") !== 4 && GatewayMemoryList.indexOf("3072 GB") !== -1) {
                        GatewayMemoryList.pop();
                      }
                      }
                    }

                  }
                }
              }
            }
          }
        })
        break;
      case "Edge Node":
        EdgeprocessorValue = e.value;
        break;
      case "Master Node":
        HeadprocessorTypeValue = e.value;
        HeadProcList = []
        this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
          if (ServiceName.functionName === node) {
            for (let key in ServiceName.totalList) {
              if (key === HeadserverValue) {
                HeadProcList = []
                for (let proctype in ServiceName.totalList[key].ProcessorList) {
                  if (proctype === HeadprocessorTypeValue) {
                    for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                      if (HeadProcList.indexOf(proc) === -1) {
                        HeadProcList.push(proc);
                      }
                      HeadprocessorValue = HeadProcList[0];
                      if (proc === HeadprocessorValue) {
                        HeadMemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                        if (HeadserverValue === "Synergy 480 Gen10 Server" && HeadprocessorValue.indexOf("M") !== 4 && HeadprocessorValue.indexOf("L") !== 4 && HeadMemoryList.indexOf("3072 GB") !== -1) {
                          HeadMemoryList.pop();
                        }
                      }

                    }

                  }
                }
              }
            }
          }
        })
        break;
    }
    // if (HeadMemoryList.indexOf(HeadmemoryValue) === -1) {
    //   HeadmemoryValue = HeadMemoryList[0];
    // }
    this.onWorkloadUpdate();
  }
  onDataDiskChange = (e, node) => {
    var OSInputs = {};
    switch (node) {
      case "Gateway Node":
        GatewaydatadisktypValue = e.value;
        //GatewayserverValue=e.value;
        OSInputs = {
          "strFunction": "Gateway Node",
          "strService": "",
          "strServer": GatewayserverValue,
          "strDataDisk": GatewaydatadisktypValue,
        }
        this.props.OnGetOSDiskList(OSInputs);
        break;
      case "Edge Node":
        EdgedatadisktypValue = e.value;
        break;
      case "Master Node":
        HeaddatadisktypValue = e.value;
        // HeadserverValue=e.value;
        OSInputs = {
          "strFunction": "Master Node",
          "strService": "",
          "strServer": HeadserverValue,
          "strDataDisk": HeaddatadisktypValue,
        }
        this.props.OnGetOSDiskList(OSInputs);
        break;
    }
    this.onWorkloadUpdate();
    if (node === "Gateway Node") {
      GatewayDiskQtyvalue = this.noOfDrivesleft(node, "");
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.Hardware["@DiskQty"] = GatewayDiskQtyvalue
    } else {
      HeadnodesQtyValue = this.noOfDrivesleft(node, "");
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.Hardware["@DiskQty"] = HeadnodesQtyValue
    }
  }
  onMemoryChange(e, node) {
    switch (node) {
      case "Gateway Node":
        GatewaymemoryValue = e.value;
        break;
      case "Edge Node":
        EdgememoryValue = e.value;
        break;
      case "Master Node":
        HeadmemoryValue = e.value;
        break;
    }
    this.onWorkloadUpdate();
  }
  // onNodeQtyChange(e, node) {
  //   switch (node) {
  //     case "Gateway Node":
  //       GatewayNodeQtyValue = e.value;
  //       break;
  //     case "Edge Node":
  //       EdgeNodeQtyValue = e.value;
  //       break;
  //   }
  //   this.onWorkloadUpdate();
  // }
  onNoOfDisksChange = (e, node, title, chorblr, editexisting, driveID) => {
    let maxDrivesLeft = ""
    let globalValue = ""
    editExisting = editexisting;
    maxDrivesLeft = this.noOfDrivesleft(node, driveID)
    var number = /^[0-9]+$/
    if (chorblr === "Change") {
      /* Changes by Vinay to check negative value */
      if(isNaN(e.target.value) || e.target.value < 0){

      }
      else if (parseInt(e.target.value, 10) > maxDrivesLeft) {
        e.target.value = maxDrivesLeft.toString()
        globalValue = e.target.value;
      }
      else {
        globalValue = e.target.value;
      }
    } else {
      if (e.target.value.length < 3) {
        var value = parseInt(e.target.value, 10);
        if (isNaN(value) || value == 0) {
          globalValue = "0";
          if (editExisting) {
            globalValue = "1";
          }
        }
        else if ((number.test(value)) && (value < maxDrivesLeft) && (value >= 1) || isNaN(value)) {
          globalValue = value.toString();
        }
        else {
          globalValue = maxDrivesLeft.toString();
        }
      }
      if (value > maxDrivesLeft) {
        this.maxDriveCountValidation(node);
      }
    }
    if (editExisting) {
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.DataDisks[driveID].Item["@qty"] = globalValue
    }
    else {
      if (node === "Gateway Node") {
        GatewayDiskQtyvalue = globalValue
      } else {
        HeadnodesQtyValue = globalValue
      }
        
    }
    if (chorblr === Constants.BLUR) {
      if(editExisting) {
        if (node === Constants.GATEWAY_NODE) {
          GatewayDiskQtyvalue = this.noOfDrivesleft(node, "");
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.Hardware["@DiskQty"] = GatewayDiskQtyvalue
        } else {
          HeadnodesQtyValue = this.noOfDrivesleft(node, "");
          this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === node)[0].Service.Hardware["@DiskQty"] = HeadnodesQtyValue
        }
      }
    }
    this.onWorkloadUpdate();
    editExisting = false;
  }
  onNoOfOSDisksChange(e, node, chorblr) {
    switch (node) {
      case "Gateway Node":
        if (chorblr === "Change") {
          if (parseInt(e.target.value, 10) > 2) {
            e.target.value = "2"
          }
        } else {
          if (e.target.value === "")
            e.target.value = "1"
        }
        GatewayOSDiskQtyvalue = e.target.value;
        GateNodeOSdiskqtynotchange = false
        this.maxDriveCountValidation(node)
        break;
      case "Edge Node":
        EdgenodeDiskQtyvalue = e.target.value;
        break;
      case "Master Node":
        if (chorblr === "Change") {
          if (parseInt(e.target.value, 10) > 2) {
            e.target.value = "2"
          }
        } else {
          if (e.target.value === "")
            e.target.value = "1"
        }
        HeadnodesOSDisksQtyValue = e.target.value;
        HeadOSdiskqtynotchange = false
        this.maxDriveCountValidation(node)
        break;
    }
    this.onWorkloadUpdate();
  }
  MasterCheckboxChange(e) {
    let flag;
    if (MasterChecked) {
      MasterChecked = false
      flag = 'false'
      removeObject('Master Node',false,this.props.workload);
    } else {
      MasterChecked = true
      flag = 'true'
    }
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      switch (val['@Type']) {
        case "Master Node":
          val.Service['@Selected'] = MasterChecked.toString()
      }
    })
    this.setState({})
  }
  GatewayCheckboxChange(e) {
    let flag;
    if (GatewayChecked) {
      GatewayChecked = false
      flag = 'false';
      removeObject('Gateway Node',false,this.props.workload);
    } else {
      GatewayChecked = true
      flag = 'true'
    }
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      switch (val['@Type']) {
        case "Gateway Node":
          val.Service['@Selected'] = GatewayChecked.toString()
      }
    })
    this.setState({})

  }
  onWorkloadUpdate(e) {
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      switch (val['@Type']) {
        case "Gateway Node":
          val.Service.Hardware['@Server'] = GatewayserverValue;
          val.Service.Hardware['@Proc'] = GatewayprocessorValue;
          val.Service.Hardware['@ProcFamily'] = GatewayprocessorTypeValue
          val.Service.Hardware['@ProcQty'] = GatewaypocQtyValue
          val.Service.Hardware['@DataDisk'] = GatewaydatadisktypValue;
          val.Service.Hardware['@OSDisk'] = GatewayosdisktypValue;
          val.Service.Hardware['@DiskQty'] = GatewayDiskQtyvalue;
          val.Service.Hardware['@OSDiskQty'] = GatewayOSDiskQtyvalue;
           if (GatewayserverValue === "Synergy 480 Gen10 Server" && GatewayprocessorValue.indexOf("M") !== 4 && GatewayprocessorValue.indexOf("L") !== 4 && GatewayMemoryList.indexOf("3072 GB") !== -1) {
                        GatewayMemoryList.pop();
                      }
           if ( GatewayMemoryList.length > 0 && GatewayMemoryList.indexOf(GatewaymemoryValue) === -1) {
            GatewaymemoryValue = GatewayMemoryList[0];
          }
          val.Service.Hardware['@Memory'] = GatewaymemoryValue;
          val.Service.Hardware['@NodesCount'] = GatewayNodeQtyValue;
          val.Service.Hardware['@NodesQty'] = GatewaySizerNodeQtyValue
          break;
        case "Edge Node":
          val.Service.Hardware['@Server'] = EdgeserverValue;
          val.Service.Hardware['@Proc'] = EdgeprocessorValue;
          val.Service.Hardware['@ProcQty'] = EdgepocQtyValue
          val.Service.Hardware['@DataDisk'] = EdgedatadisktypValue;
          val.Service.Hardware['@OSDisk'] = EdgeosdisktypValue;
          val.Service.Hardware['@DiskQty'] = EdgenodeDiskQtyvalue;
          val.Service.Hardware['@Memory'] = EdgememoryValue;
          val.Service.Hardware['@NodesQty'] = EdgeNodeQtyValue;
          break;
        case "Master Node":
          val.Service.Hardware['@Server'] = HeadserverValue;
          val.Service.Hardware['@Proc'] = HeadprocessorValue;
          val.Service.Hardware['@ProcFamily'] = HeadprocessorTypeValue
          val.Service.Hardware['@ProcQty'] = HeadpocQtyValue
          val.Service.Hardware['@DataDisk'] = HeaddatadisktypValue;
          val.Service.Hardware['@OSDisk'] = HeadosdisktypValue;
          val.Service.Hardware['@DiskQty'] = HeadnodesQtyValue;
          val.Service.Hardware['@OSDiskQty'] = HeadnodesOSDisksQtyValue;
          if (HeadserverValue === "Synergy 480 Gen10 Server" && HeadprocessorValue.indexOf("M") !== 4 && HeadprocessorValue.indexOf("L") !== 4 && HeadMemoryList.indexOf("3072 GB") !== -1) {
            HeadMemoryList.pop();
          }
          if (HeadMemoryList.length > 0 && HeadMemoryList.indexOf(HeadmemoryValue) === -1) {
            HeadmemoryValue = HeadMemoryList[0];
          }
          val.Service.Hardware['@Memory'] = HeadmemoryValue;
          val.Service.Hardware['@NodesQty'] = MasterNodeQtyValue;
          val.Service.Hardware['@NodesCount'] = MasternodesQtyValue;
          break;
      }
    })
    this.setState({})
  }
  componentWillUnmount() {
    let ServicesArray = ["Master Node", "Gateway Node"]
    this.props.defaultSizerWorkload.serversList.map((ServiceName, id) => {
      if (ServiceName.functionName === "Gateway Node") {
        this.props.defaultSizerWorkload.serversList.splice(id, 1);
        //  id=id-1
      }
    })
    this.props.defaultSizerWorkload.serversList.map((ServiceName, id) => {
      if (ServiceName.functionName === "Master Node") {
        this.props.defaultSizerWorkload.serversList.splice(id, 1);
        // id=id-1
      }
    })

    let Hardware = ""
    let diskNumber = ""
    ServicesArray.forEach(service => {
    Hardware = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.Hardware
    diskNumber = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks.length
    let isMixedStorageConfiguration = this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service["@mixedStorage"]
    
    if(isMixedStorageConfiguration==="False") {
      let newDrive = { Item : {
        "@disk" : Hardware["@DataDisk"],
        "@qty": Hardware["@DiskQty"],
        "@volumeName": "Data_0"
      } }
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks = []
      this.props.workload.UserInputs.Environments.Functions.Function.filter(x=>x["@Type"] === service)[0].Service.DataDisks.push(newDrive);
    }
    })

    // this.props.defaultSizerWorkload.serversList.map((ServiceName, id) => {
    //   if (ServiceName.functionName === "Master Node") {
    //     this.props.defaultSizerWorkload.serversList.splice(id, 1);
    //     // id=id-1
    //   }
    // })
    console.log(this.props.defaultSizerWorkload.serversList)
  }
  render() {
    let GatewaySizerRecmdtnServer, GatewaySizerRecmdtnProcsr, GatewaySizerRecmdtnMemory, GatewaySizerRecmdtnDisktype;
    //let EdgeSizerRecmdtnServer, EdgeSizerRecmdtnProcsr, EdgeSizerRecmdtnMemory, EdgeSizerRecmdtnDisktype, EdgedefaultNodevalue;
    let MasterSizerRecmdtnServer, MasterSizerRecmdtnProcsr, MasterSizerRecmdtnMemory, MasterSizerRecmdtnDisktype;
    let layer = ""
    let MasterNodeNodeOtyOPtions = []
    let GatewayNodeNodeOtyOPtions = []
    GatewayServers = []
    HeadServers = []
    GatewayProcFamilyList = []
    HeadProcList = []
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      switch (val['@Type']) {
        case "Gateway Node":
          GatewayChecked = (/true/i).test(val.Service['@Selected'])
          GatewayserverValue = val.Service.Hardware['@Server'];
          GatewayprocessorValue = val.Service.Hardware['@Proc'];
          GatewayprocessorTypeValue = val.Service.Hardware['@ProcFamily']
          GatewaypocQtyValue = val.Service.Hardware['@ProcQty'];
          GatewaydatadisktypValue = val.Service.Hardware['@DataDisk'];
          GatewayosdisktypValue = val.Service.Hardware['@OSDisk'];
          GatewayDiskQtyvalue = val.Service.Hardware['@DiskQty'];
          GatewayOSDiskQtyvalue = val.Service.Hardware['@OSDiskQty'];
          GatewaymemoryValue = val.Service.Hardware['@Memory'];
	  isMixedStorageConfigurationgateWay = val.Service["@mixedStorage"];
          if (GatewaySizerNodeQtyValue === "User Defined" && GatewayNodeQtyValue === "1 Per Rack") {
            val.Service.Hardware['@NodesCount'] = "1"
          }
          else if (GatewaySizerNodeQtyValue === "Sizer Recommendation") {
            val.Service.Hardware['@NodesCount'] = val.Service.Recommendation['@NodesCount']
          }
          GatewayNodeQtyValue = val.Service.Hardware['@NodesCount'];
          GatewaySizerNodeQtyValue = val.Service.Hardware['@NodesQty']
          GatewayNodeNodeOtyOPtions = ["User Defined", "Sizer Recommendation"]

          GatewaySizerRecmdtnServer = val.Service.Recommendation['@Name'];
          GatewaySizerRecmdtnProcsr = val.Service.Recommendation['@Proc'];
          GatewaySizerRecmdtnDisktype = val.Service.Recommendation['@DataDisk'];

          GatewaydefaultNodevalue = val.Service.Recommendation['@NodesCount'];
          GatewaySizerRecmdtnMemory = val.Service.Recommendation['@Memory'];

          break;
        case "Edge Node":
          EdgeserverValue = val.Service.Hardware['@Server'];
          EdgeprocessorValue = val.Service.Hardware['@Proc'];
          EdgepocQtyValue = val.Service.Hardware['@ProcQty'];
          EdgedatadisktypValue = val.Service.Hardware['@DataDisk'];
          EdgeosdisktypValue = val.Service.Hardware['@OSDisk'];
          EdgenodeDiskQtyvalue = val.Service.Hardware['@DiskQty'];
          EdgememoryValue = val.Service.Hardware['@Memory'];
          EdgeNodeQtyValue = val.Service.Hardware['@NodesQty'];

          //EdgeSizerRecmdtnServer = val.Service.Recommendation['@Name'];
          //EdgeSizerRecmdtnProcsr = val.Service.Recommendation['@Proc'];
          //EdgeSizerRecmdtnDisktype = val.Service.Recommendation['@DataDisk'];
          //EdgedefaultNodevalue = val.Service.Recommendation['@NodesCount'];
          //EdgeSizerRecmdtnMemory = val.Service.Recommendation['@Memory'];
          break;
        case "Master Node":
          MasterChecked = (/true/i).test(val.Service['@Selected'])
          HeadserverValue = val.Service.Hardware['@Server'];
          HeadprocessorValue = val.Service.Hardware['@Proc'];
          HeadprocessorTypeValue = val.Service.Hardware['@ProcFamily'];
          HeadpocQtyValue = val.Service.Hardware['@ProcQty'];
          HeaddatadisktypValue = val.Service.Hardware['@DataDisk'];
          HeadosdisktypValue = val.Service.Hardware['@OSDisk'];
          HeadnodesQtyValue = val.Service.Hardware['@DiskQty'];
          HeadnodesOSDisksQtyValue = val.Service.Hardware['@OSDiskQty'];
          HeadmemoryValue = val.Service.Hardware['@Memory'];
          MasterNodeQtyValue = val.Service.Hardware['@NodesQty']
	  isMixedStorageConfigurationmasterNode = val.Service["@mixedStorage"];
          MasterNodeNodeOtyOPtions = ["User Defined", "Sizer Recommendation"]

          //  if(parseInt(val.Service.Hardware['@NodesCount'], 10) < parseInt(val.Service.Recommendation['@NodesCount'], 10))
          //   val.Service.Hardware['@NodesCount']=val.Service.Recommendation['@NodesCount'];
          if (MasterNodeQtyValue === "Sizer Recommendation") {
            val.Service.Hardware['@NodesCount'] = val.Service.Recommendation['@NodesCount']
          }
          MasternodesQtyValue = val.Service.Hardware['@NodesCount']

          MasterSizerRecmdtnServer = val.Service.Recommendation['@Name'];
          MasterSizerRecmdtnProcsr = val.Service.Recommendation['@Proc'];
          MasterSizerRecmdtnDisktype = val.Service.Recommendation['@DataDisk'];
          MasterdefaultNodevalue = val.Service.Recommendation['@NodesCount'];
          MasterSizerRecmdtnMemory = val.Service.Recommendation['@Memory'];

          break;
      }
    })
    if (this.props.defaultSizerWorkload.serversList !== "" && this.props.defaultSizerWorkload.serversList !== undefined && this.props.defaultSizerWorkload.serversList !== null) {
      this.props.defaultSizerWorkload.serversList.map((ServiceName) => {
        switch (ServiceName.functionName) {
          case "Gateway Node":
            for (let key in ServiceName.totalList) {
              if (key === GatewayserverValue) {
                GatewayDrives = ServiceName.totalList[key].DataDiskList;
                if (gatewayDataDriveConsolidatedOptions.length === 0) {
                  ServiceName.totalList[key].DataDiskList.map(x => {
                    x.Types.map(y => {
                      if (gatewayDataDriveConsolidatedOptions.indexOf(y) === -1) {
                        gatewayDataDriveConsolidatedOptions.push(y)
                      }
                    })
                  })
                  if (gatewayDataDriveType === "") {
                    gatewayDataDriveType = gatewayDataDriveConsolidatedOptions[0];
                  }
                }
                this.populateDataDriveoptions("Gateway Node")
                GatewayOSDiskList = ServiceName.totalList[key].OSDiskList
                for (let proctype in ServiceName.totalList[key].ProcessorList) {
                  if (GatewayProcFamilyList.indexOf(proctype) === -1) {
                    GatewayProcFamilyList.push(proctype);
                  }
                  if (proctype === GatewayprocessorTypeValue) {
                    for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                      if (GatewayProcList.indexOf(proc) === -1) {
                        GatewayProcList.push(proc);
                      }
                      if (proc === GatewayprocessorValue) {
                        GatewayMemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                         if (GatewayserverValue === "Synergy 480 Gen10 Server" && GatewayprocessorValue.indexOf("M") !== 4 && GatewayprocessorValue.indexOf("L") !== 4 && GatewayMemoryList.indexOf("3072 GB") !== -1) {
                        GatewayMemoryList.pop();
                      }
                      }
                    }

                  }
                }

              }
              if (GatewayServers.indexOf(key) === -1) {
                GatewayServers.push(key);
              }
              if (GatewayOSDiskList.indexOf(GatewayosdisktypValue) === -1) {
                GatewayosdisktypValue = GatewayOSDiskList[0]
              }
            }

            break;
          case "Master Node":
            for (let key in ServiceName.totalList) {
              if (key === HeadserverValue) {
                HeadDrives = ServiceName.totalList[key].DataDiskList
                if (masterNodeDataDriveConsolidatedOptions.length == 0) {
                  ServiceName.totalList[key].DataDiskList.map(x => {
                    x.Types.map(y => {
                      if (masterNodeDataDriveConsolidatedOptions.indexOf(y) === -1) {
                        masterNodeDataDriveConsolidatedOptions.push(y)
                      }
                    })
                  })
                  if (masterNodeDataDriveType === "") {
                    masterNodeDataDriveType = masterNodeDataDriveConsolidatedOptions[0]
                  }
                }
                this.populateDataDriveoptions("Master Node")
                // HeadMemoryList = ServiceName.totalList[key].MemoryList
                HeadOSDiskList = ServiceName.totalList[key].OSDiskList
                //   HeadProcList = ServiceName.totalList[key].ProcList
                for (let proctype in ServiceName.totalList[key].ProcessorList) {
                  if (HeadProcFamilyList.indexOf(proctype) === -1) {
                    HeadProcFamilyList.push(proctype);
                  }
                  if (proctype === HeadprocessorTypeValue) {
                    for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                      if (HeadProcList.indexOf(proc) === -1) {
                        HeadProcList.push(proc);
                      }
                      if (proc === HeadprocessorValue) {
                        HeadMemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                        if (HeadserverValue === "Synergy 480 Gen10 Server" && HeadprocessorValue.indexOf("M") !== 4 && HeadprocessorValue.indexOf("L") !== 4 && HeadMemoryList.indexOf("3072 GB") !== -1) {
                          HeadMemoryList.pop();
                        }

                      }
                    }
                  }
                }
              }
              if (HeadServers.indexOf(key) === -1) {
                HeadServers.push(key);
              }
              if (HeadOSDiskList.indexOf(HeadosdisktypValue) === -1) {
                HeadosdisktypValue = HeadOSDiskList[0]
              }
            }
            break;
        }
      })
    }
    this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
      switch (val['@Type']) {
        case "Gateway Node":
          this.props.defaultSizerWorkload.serversList.filter((ServiceName) => {
            if (ServiceName.functionName === "Gateway Node") {
              var ServerPresent = false
              for (let key in ServiceName.totalList) {
                if (key === GatewayserverValue) {
                  ServerPresent = true
                }
              }
              if (!ServerPresent) {
                val.Service.Hardware['@Server'] = GatewayServers[0];
                GatewayserverValue = val.Service.Hardware['@Server'];
                this.props.defaultSizerWorkload.serversList.filter((ServiceName) => {
                  switch (ServiceName.functionName) {
                    case "Gateway Node":
                      for (let key in ServiceName.totalList) {
                        if (key === GatewayserverValue) {
                          GatewayProcFamilyList = []
                          GatewayProcList = []
                          GatewayDrives = ServiceName.totalList[key].DataDiskList
                          ServiceName.totalList[key].DataDiskList.map(x => {
                            if(gatewayDataDriveConsolidatedOptions.length === 0 ) {
                              x.Types.map(y => {
                                if (gatewayDataDriveConsolidatedOptions.indexOf(y) === -1) {
                                  gatewayDataDriveConsolidatedOptions.push(y)
                                }
                              })
                            }
                            if (gatewayDataDriveType === "") {
                              gatewayDataDriveType = gatewayDataDriveConsolidatedOptions[0];
                            }
                          })
                          this.populateDataDriveoptions("Gateway Node")
                          GatewayOSDiskList = ServiceName.totalList[key].OSDiskList
                          for (let proctype in ServiceName.totalList[key].ProcessorList) {
                            if (GatewayProcFamilyList.indexOf(proctype) === -1) {
                              GatewayProcFamilyList.push(proctype);
                            }
                            GatewayprocessorTypeValue = GatewayProcFamilyList[0]
                            if (proctype === GatewayprocessorTypeValue) {
                              for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                                if (GatewayProcList.indexOf(proc) === -1) {
                                  GatewayProcList.push(proc);
                                }
                                if (proc === GatewayprocessorValue) {
                                  GatewayMemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                                   if (GatewayserverValue === "Synergy 480 Gen10 Server" && GatewayprocessorValue.indexOf("M") !== 4 && GatewayprocessorValue.indexOf("L") !== 4 && GatewayMemoryList.indexOf("3072 GB") !== -1) {
                        GatewayMemoryList.pop();
                      }
                                }
                              }

                            }
                          }

                        }
                        if (GatewayServers.indexOf(key) === -1) {
                          GatewayServers.push(key);
                        }
                        if (GatewayOSDiskList.indexOf(GatewayosdisktypValue) === -1) {
                          GatewayosdisktypValue = GatewayOSDiskList[0]
                        }
                      }

                      break;

                  }
                })
                val.Service.Hardware['@Proc'] = GatewayProcList[0];
                GatewayprocessorValue = val.Service.Hardware['@Proc'];
                val.Service.Hardware['@ProcFamily'] = GatewayProcFamilyList[0]
                GatewayprocessorTypeValue = val.Service.Hardware['@ProcFamily']
                GatewaypocQtyValue = val.Service.Hardware['@ProcQty'];
                val.Service.Hardware['@DataDisk'] = GatewayDrives[0]
                GatewaydatadisktypValue = val.Service.Hardware['@DataDisk'];
                val.Service.Hardware['@OSDisk'] = GatewayosdisktypValue[0]
                GatewayosdisktypValue = val.Service.Hardware['@OSDisk'];
                val.Service.Hardware['@Memory'] = GatewayMemoryList[0]
                GatewaymemoryValue = val.Service.Hardware['@Memory'];
                // GatewayDiskQtyvalue = val.Service.Hardware['@DiskQty'];
                // GatewayOSDiskQtyvalue = val.Service.Hardware['@OSDiskQty'];
              }
            }
          })
          break
        case "Master Node":
          this.props.defaultSizerWorkload.serversList.filter((ServiceName) => {
            if (ServiceName.functionName === "Master Node") {
              var ServerPresent = false
              for (let key in ServiceName.totalList) {
                if (key === HeadserverValue) {
                  ServerPresent = true
                }
              }
              if (!ServerPresent) {
                val.Service.Hardware['@Server'] = GatewayServers[0];
                HeadserverValue = val.Service.Hardware['@Server'];
                this.props.defaultSizerWorkload.serversList.filter((ServiceName) => {
                  switch (ServiceName.functionName) {
                    case "Master Node":
                      for (let key in ServiceName.totalList) {
                        if (key === HeadserverValue) {
                          HeadProcFamilyList = []
                          HeadProcList = []
                          HeadDrives = ServiceName.totalList[key].DataDiskList
                          ServiceName.totalList[key].DataDiskList.map(x => {
                            if(masterNodeDataDriveConsolidatedOptions.length == 0) {
                              x.Types.map(y => {
                                if (masterNodeDataDriveConsolidatedOptions.indexOf(y) === -1) {
                                  masterNodeDataDriveConsolidatedOptions.push(y)
                                }
                              })
                            }
                            if (masterNodeDataDriveType === "") {
                              masterNodeDataDriveType = masterNodeDataDriveConsolidatedOptions[0]
                            }
                          })
                          this.populateDataDriveoptions("Master Node")
                          HeadOSDiskList = ServiceName.totalList[key].OSDiskList
                          for (let proctype in ServiceName.totalList[key].ProcessorList) {
                            if (HeadProcFamilyList.indexOf(proctype) === -1) {
                              HeadProcFamilyList.push(proctype);
                            }
                            HeadprocessorTypeValue = HeadProcFamilyList[0]
                            if (proctype === HeadprocessorTypeValue) {
                              for (let proc in ServiceName.totalList[key].ProcessorList[proctype]) {
                                if (HeadProcList.indexOf(proc) === -1) {
                                  HeadProcList.push(proc);
                                }
                                if (proc === HeadprocessorValue) {
                                  HeadMemoryList = ServiceName.totalList[key].ProcessorList[proctype][proc]
                                  if (HeadserverValue === "Synergy 480 Gen10 Server" && HeadprocessorValue.indexOf("M") !== 4 && HeadprocessorValue.indexOf("L") !== 4 && HeadMemoryList.indexOf("3072 GB") !== -1) {
                                    HeadMemoryList.pop();
                                  }
                                }
                              }

                            }
                          }

                        }
                        if (HeadServers.indexOf(key) === -1) {
                          HeadServers.push(key);
                        }
                        if (HeadOSDiskList.indexOf(HeadosdisktypValue) === -1) {
                          HeadosdisktypValue = HeadOSDiskList[0]
                        }
                      }

                      break;

                  }
                })
                val.Service.Hardware['@Proc'] = HeadProcList[0];
                HeadprocessorValue = val.Service.Hardware['@Proc'];
                val.Service.Hardware['@ProcFamily'] = HeadProcFamilyList[0]
                HeadprocessorTypeValue = val.Service.Hardware['@ProcFamily']
                HeadpocQtyValue = val.Service.Hardware['@ProcQty'];
                val.Service.Hardware['@DataDisk'] = HeadDrives[0]
                HeaddatadisktypValue = val.Service.Hardware['@DataDisk'];
                val.Service.Hardware['@OSDisk'] = HeadOSDiskList[0]
                HeadosdisktypValue = val.Service.Hardware['@OSDisk'];
                val.Service.Hardware['@Memory'] = HeadMemoryList[0]
                HeadmemoryValue = val.Service.Hardware['@Memory'];
                // GatewayDiskQtyvalue = val.Service.Hardware['@DiskQty'];
                // GatewayOSDiskQtyvalue = val.Service.Hardware['@OSDiskQty'];
              }
            }
          })
          break
      }
    })
    if (this.props.defaultSizerWorkload.serversList !== "" && this.props.defaultSizerWorkload.serversList !== undefined && this.props.defaultSizerWorkload.serversList !== null) {
      this.props.defaultSizerWorkload.serversList.map((ServiceName) => {

        switch (ServiceName.functionName) {
          case "Gateway Node":
            for (let key in ServiceName.totalList) {
              if (key === GatewayserverValue) {
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                  if (val['@Type'] === "Gateway Node") {
                    if( GatewayDrives.indexOf(val.Service.Hardware["@DataDisk"]) === -1) {
                      val.Service.Hardware["@DataDisk"] = GatewayDrives[0]
                      GatewaydatadisktypValue = val.Service.Hardware["@DataDisk"]
                    }
                    // if(GateNodeDatadiskqtynotchange){
                    //GatewayDiskQtyvalue = ServiceName.totalList[key].iDataDiskQty.toString();
                    //  val.Service.Hardware['@DiskQty']= GatewayDiskQtyvalue
                    //  }else{
                    GatewayDiskQtyvalue = val.Service.Hardware['@DiskQty'];
                    //     }
                    if (GateNodeOSdiskqtynotchange) {
                      GatewayOSDiskQtyvalue = ServiceName.totalList[key].iOSDiskQty.toString();
                      val.Service.Hardware['@OSDiskQty'] = GatewayOSDiskQtyvalue
                    } else {
                      GatewayOSDiskQtyvalue = val.Service.Hardware['@OSDiskQty'];
                    }
                  }
                })
                GateNodeMaxDriveQty = ServiceName.totalList[key].iMaxDrives
              }
            }
            break;
          case "Master Node":
            for (let key in ServiceName.totalList) {
              if (key === HeadserverValue) {
                this.props.workload.UserInputs.Environments.Functions.Function.filter((val) => {
                  if (val['@Type'] === "Master Node") {
                    if( HeadDrives.length > 0 &&  HeadDrives.indexOf(val.Service.Hardware["@DataDisk"]) === -1) {
                      val.Service.Hardware["@DataDisk"] = HeadDrives[0]
                      HeaddatadisktypValue = val.Service.Hardware["@DataDisk"]
                    }
                    // if(HeadDatadiskqtynotchange){
                    //HeadnodesQtyValue = ServiceName.totalList[key].iDataDiskQty.toString();
                    //  val.Service.Hardware['@DiskQty']= HeadnodesQtyValue
                    // }else{
                    HeadnodesQtyValue = val.Service.Hardware['@DiskQty'];
                    //  }
                    if (HeadOSdiskqtynotchange) {
                      HeadnodesOSDisksQtyValue = ServiceName.totalList[key].iOSDiskQty.toString();
                      val.Service.Hardware['@OSDiskQty'] = HeadnodesOSDisksQtyValue
                    } else {
                      HeadnodesOSDisksQtyValue = val.Service.Hardware['@OSDiskQty'];
                    }
                  }
                })
                HeadNodeMaxDriveQty = ServiceName.totalList[key].iMaxDrives
              }
            }
            break;
        }
      })
      if (maxlayer) {
        layer = <Layer style={{ zIndex: '500 !important' }}>
          <Box direction="row" margin="none" separator="bottom" style={{ padding: "none", backgroundColor: "#425563" }} >
            <Box direction="row" margin="none" pad="none" align='start' style={{ width: '96%', padding: "10px", color: "#fff" }}>
              <Heading tag="h4" strong={true} style={{ marginBottom: '0px' }}>Error</Heading>
            </Box>
            <Box direction="row" style={{ marginTop: "10px", padding: "5px" }} margin="none" pad="none" align='start' alignContent="start" onClick={(e) => this.layerclose(e, functionnode)} >
              <CloseIcon size='small' colorIndex="light-2" style={{ stroke: 'white' }} />
            </Box>
          </Box>
          <Box style={{ padding: "10px" }}>
      <Paragraph>Disk Quantity requested exceeds the limit of {maxDrivevalue} for the selected server.</Paragraph>
          </Box>
        </Layer>

      }

    }

    var LoadindData = '';
    if (this.props.isLoading) {
      LoadindData = <Layer style={{ zIndex: '500 !important' }}>
        <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
          <Spinning className="Spinning" size='small' />
          <Heading tag='h5' margin='none' style={{ color: "#fff" }}>Initialising Configuration</Heading>
        </Box>
      </Layer>
    }
    if (MasterNodeQtyValue === "User Defined") {
      NodeQtyvisible = false
    } else {
      NodeQtyvisible = true
    }
    if (GatewaySizerNodeQtyValue === "User Defined") {
      GatewayNodeQtyvisible = false
    } else {
      GatewayNodeQtyvisible = true
    }


    if (!MasterChecked) {
      HeadserverValue = 'None'
      HeadosdisktypValue = 'None'
      HeadprocessorValue = 'None'
      HeadprocessorTypeValue = 'None'
      HeaddatadisktypValue = 'None'
      HeadpocQtyValue = 'None'
      HeadmemoryValue = 'None'
      HeadnodesQtyValue = 'None'
      HeadnodesOSDisksQtyValue = 'None'
      MasterNodeQtyValue = 'None'



      HeadServers = []
      HeadOSDiskList = []
      HeadProcList = []
      HeadProcFamilyList = []
      HeadDrives = []
      HeadMemoryList = []
      MasterNodeNodeOtyOPtions = []
    }

    if (MasterNodeQtyValue === 'None') {
      NodeQtyvisible = true
    }
    if (!GatewayChecked) {

      GatewayserverValue = 'None'
      GatewayosdisktypValue = 'None'
      GatewayOSDiskList = 'None'
      GatewayprocessorValue = 'None'
      GatewayprocessorTypeValue = 'None'
      GatewaydatadisktypValue = 'None'
      //HeadmemoryValue = 'None'
      GatewaypocQtyValue = 'None'
      GatewaymemoryValue = 'None'
      GatewayDiskQtyvalue = 'None'
      GatewayOSDiskQtyvalue = 'None'
      GatewayNodeQtyValue = 'None'
      GatewaySizerNodeQtyValue = 'None'

      GatewayServers = []
      GatewayProcList = []
      GatewayProcFamilyList = []
      GatewayDrives = []
      GatewayMemoryList = []
      GatewayNodeNodeOtyOPtions = []
      // GatewaydefaultNodevalue = ""
    }
    var MasterSizerdispaly = "none"
    var GatewaySizerdisplay = "none"
    var GatewayOSDiskQtyvalue = "None"
    var MasterOSDiskQtyvalue = "None"
    if (MasterChecked) {
      MasterSizerdispaly = " "
      MasterOSDiskQtyvalue = "2"
    }
    if (GatewayChecked) {
      GatewaySizerdisplay = " "
      GatewayOSDiskQtyvalue = "2"
    }
    if (GatewaySizerNodeQtyValue === 'None') {
      GatewayNodeQtyvisible = true
    }

    return (
      <Box pad='none' margin='none' style={{ position: 'relative', width: '100%' }}>
        <ReactTooltip place="right" multiline={true} />
        {LoadindData}
        {serverChangeConfirmationlayer}
        <Article full={true} margin="none" pad={{ between: 'small' }} style={{ maxHeight: '96%' }} >
          <Tabs justify='start' activeIndex={this.state.activeIndex} onActive={(e) => {
            this.setState(
              {
                activeIndex: e
              }); this.props.defaultSizerWorkload.Indexes.extraConfiguration = e
          } }>

            <Tab title="Master Node">
              <Box margin="none" pad="none">
                {layer}
                <Paragraph style={{ margin: "0px", paddingLeft: '10px', maxWidth: "700px" }}>Master Node nodes run Hadoop master processes such as the HDFS NameNode and YARN Resource Manager.</Paragraph>
                <Box pad="small" margin="small" style={{ marginTop: '10px', padding: '0px', width: '15%' }}>
                  <CheckBox className="CheckboxSeparate" label='Add Master Node' style={{ marginRight: '0px' }} checked={MasterChecked} onChange={(e) => this.MasterCheckboxChange(e)} />
                </Box>
                <Box style={{ padding: "10px", overflow: 'auto', width: '95%' }} pad={{ between: 'small' }} >
                  <Box direction='row' pad={{ between: 'small' }}>
                    <FormField className="DiskCapacityDetails" label='Server' error={this.state.DiskCapacityerror} style={{ width: '30%', minWidth:'200px'}}>
                      <Select placeHolder='None' value={HeadserverValue} options={HeadServers} onChange={(e) => this.onServerChange(e, "Master Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='Processor Family' style={{ width: '20%', minWidth:'147px'}}>
                      <Select placeHolder='None' value={HeadprocessorTypeValue} options={HeadProcFamilyList} onChange={(e) => this.onProcessorFamilytypeChange(e, "Master Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='Processor' style={{ width: '25%', minWidth:'127px'}}>
                      <Select placeHolder='None' value={HeadprocessorValue} options={HeadProcList} onChange={(e) => this.onProcessorChange(e, "Master Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='Proc Qty' style={{ width: '12%', minWidth:'110px'}}>
                      <Select placeHolder='None' value={HeadpocQtyValue} onChange={(e) => this.onProcQtyChange(e, "Master Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='Memory' style={{ width: '13%', minWidth:'141px'}}>
                      <Select placeHolder='None' value={HeadmemoryValue} options={HeadMemoryList} onChange={(e) => this.onMemoryChange(e, "Master Node")} />
                    </FormField>
                  </Box>
                  <DataDrive dataDriveType={masterNodeDataDriveType} dataDriveConsolidatedOptions={masterNodeDataDriveConsolidatedOptions} onDatadriveTypeChange={this.onMasterNodeDataDriveTypeChange} Drives={HeadDrives} dataDiskValue={HeaddatadisktypValue} type="Master Node" title="" onDataDiskChange={this.onDataDiskChange} noOfDisksValue={HeadnodesQtyValue} onNoOfDisksChange={this.onNoOfDisksChange} onAddingDataDisk={this.onAddingDataDisk} renderTable={this.renderTable} isMixedStorage={isMixedStorageConfigurationmasterNode} enableADDButton ={true} workloadType={Constants.BIG_DATA}/> 
                  <Box direction='row' pad={{ between: 'small' }}>
                    <FormField className="DiskCapacityDetails" label='OS Disk' error={this.state.DiskCapacityerror} >
                      <Select placeHolder='None' value={HeadosdisktypValue} options={HeadOSDiskList} onChange={(e) => this.onOSDiskChange(e, "Master Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='No. of OS Disks'>
                      <TextInput placeHolder='None' value={MasterOSDiskQtyvalue} />
                      {/*<TextInput placeHolder='None' value={HeadnodesOSDisksQtyValue} onDOMChange={(e)=>this.onNoOfOSDisksChange(e,"Master Node","Change")} onBlur={(e)=>this.onNoOfOSDisksChange(e,"Master Node","Blur")}/>*/}
                    </FormField>
                  </Box>
                </Box>
                <Box direction="row" pad={{ between: 'small' }} style={{ width: '70%', paddingLeft: "9px" }} >
                  <FormField className="DiskCapacityDetails" label='Nodes Quantity' style={{ width: '44%' }} >
                    <Select className="NodeSelect" placeHolder='None' value={MasterNodeQtyValue} options={MasterNodeNodeOtyOPtions} onChange={(e) => this.onMasterNodeQtyValueChange(e)} />
                  </FormField>
                  <Box direction="row" alignContent='center' align='center' >
                    <TextInput id='UserDefined' hidden={NodeQtyvisible} style={{ width: '44%' }} value={MasternodesQtyValue} onBlur={(e) => this.onMasterNodevalueBlur(e)} onDOMChange={(e) => this.onMasterNodevalueChange(e)} />
                    <Paragraph className='DesignrequirementsPara' hidden={NodeQtyvisible} style={{ marginLeft: "10px", fontWeight: '600' }}>{"Minimum Nodes required:" + MasterdefaultNodevalue}</Paragraph>
                  </Box>
                </Box>
                <Box style={{ display: MasterSizerdispaly }}>
                  <Paragraph className='DesignrequirementsPara' style={{ margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}>Sizer Recommendation:</Paragraph>
                  <Paragraph className='DesignrequirementsPara' style={{ margin: "0px", paddingLeft: "20px", fontWeight: '600', paddingTop: '0px' }}>{MasterSizerRecmdtnServer} / {MasterSizerRecmdtnProcsr} / {MasterSizerRecmdtnDisktype} / {MasterSizerRecmdtnMemory} / {MasterdefaultNodevalue + " Nodes"}</Paragraph>
                </Box>
              </Box>
            </Tab>
            <Tab title="Gateway Node">
              <Box margin="none" pad="none">
                {layer}
                <Box direction='row'>
                  <ReactTooltip place="right" multiline={true} />
                  <Paragraph style={{ margin: "0px", paddingLeft: '10px' }}>Gateway Node nodes are client access points for launching jobs in the cluster.</Paragraph>
                  <CircleInformation data-tip="Gateway Node quantity is calculated based on the total host count in the Function screen excluding Scality and AI (Tenserflow and PyTorch) service nodes." colorIndex="accent-3" style={{ width: "20px", height: "20px", marginBottom: '6px', marginLeft:'0.4%'}} />
                </Box>
                <Box pad="small" margin="small" style={{ marginTop: '10px', padding: '0px', width: '15%' }}>
                  <CheckBox className="CheckboxSeparate" label='Add Gateway Node' style={{ marginRight: '0px' }} checked={GatewayChecked} onChange={(e) => this.GatewayCheckboxChange(e)} />
                </Box>

                <Box style={{ padding: "10px", overflow: 'auto', width: '95%' }} pad={{ between: 'small' }} >
                  <Box direction='row' pad={{ between: 'small' }}>
                    <FormField className="DiskCapacityDetails" label='Server' error={this.state.DiskCapacityerror} style={{ width: '30%', minWidth:'200px'}}>
                      <Select placeHolder='None' value={GatewayserverValue} options={GatewayServers} onChange={(e) => this.onServerChange(e, "Gateway Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='Processor Family' error={this.state.DiskCapacityerror} style={{ width: '20%', minWidth:'147px'}}>
                      <Select placeHolder='None' value={GatewayprocessorTypeValue} options={GatewayProcFamilyList} onChange={(e) => this.onProcessorFamilytypeChange(e, "Gateway Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='Processor' error={this.state.DiskCapacityerror} style={{ width: '25%', minWidth:'127px'}}>
                      <Select placeHolder='None' value={GatewayprocessorValue} options={GatewayProcList} onChange={(e) => this.onProcessorChange(e, "Gateway Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='Proc Qty' style={{ width: '12%', minWidth:'110px'}}>
                      <Select placeHolder='None' value={GatewaypocQtyValue} onChange={(e) => this.onProcQtyChange(e, "Gateway Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='Memory' style={{ width: '13%', minWidth:'141px'}}>
                      <Select placeHolder='None' value={GatewaymemoryValue} options={GatewayMemoryList} onChange={(e) => this.onMemoryChange(e, "Gateway Node")} />
                    </FormField>
                  </Box>
                  
                  <DataDrive dataDriveType={gatewayDataDriveType} dataDriveConsolidatedOptions={gatewayDataDriveConsolidatedOptions} onDatadriveTypeChange={this.ongatewayDataDriveTypeChange} Drives={GatewayDrives} dataDiskValue={GatewaydatadisktypValue} type="Gateway Node" title="" onDataDiskChange={this.onDataDiskChange} noOfDisksValue={GatewayDiskQtyvalue} onNoOfDisksChange={this.onNoOfDisksChange} onAddingDataDisk={this.onAddingDataDisk} renderTable={this.renderTable} isMixedStorage={isMixedStorageConfigurationgateWay} enableADDButton ={true} workloadType={Constants.BIG_DATA}/>
                  <Box direction='row' pad={{ between: 'small' }}>
                    <FormField className="DiskCapacityDetails" label='OS Disk' error={this.state.DiskCapacityerror} >
                      <Select placeHolder='None' value={GatewayosdisktypValue} options={GatewayOSDiskList} onChange={(e) => this.onOSDiskChange(e, "Gateway Node")} />
                    </FormField>
                    <FormField className="DiskCapacityDetails" label='No. of OS Disks'>
                      <TextInput placeHolder='None' value={GatewayOSDiskQtyvalue} />
                      {/*<TextInput placeHolder='None' value={GatewayOSDiskQtyvalue} onDOMChange={(e)=>this.onNoOfOSDisksChange(e,"Gateway Node","Change")} onBlur={(e)=>this.onNoOfOSDisksChange(e,"Gateway Node","Blur")}/>*/}
                    </FormField>
                  </Box>
                </Box>
                { /* <Box direction="row" pad={{ between: 'small' }} style={{ width: '70%', paddingLeft: "9px" }} >
                  <FormField className="DiskCapacityDetails" label='Nodes Quantity' style={{ width: '44%' }} >
                    <Select className="NodeSelect" placeHolder='None' value={GatewayNodeQtyValue} options={GatewaydefaultNodevalue} onChange={(e) => this.onNodeQtyChange(e, "Gateway Node")} />
                  </FormField>
                </Box>*/}
                <Box direction="row" pad={{ between: 'small' }} style={{ width: '70%', paddingLeft: "9px" }} >
                  <FormField className="DiskCapacityDetails" label='Nodes Quantity' style={{ width: '44%' }} >
                    <Select className="NodeSelect" placeHolder='None' value={GatewaySizerNodeQtyValue} options={GatewayNodeNodeOtyOPtions} onChange={(e) => this.onGatewayNodeQtyValueChange(e)} />
                  </FormField>
                  <Box direction="row" alignContent='center' align='center' >
                    <TextInput id='UserDefined' hidden={GatewayNodeQtyvisible} style={{ width: '44%' }} value={GatewayNodeQtyValue} onBlur={(e) => this.onGatewayNodevalueBlur(e)} onDOMChange={(e) => this.onGatewayNodevalueChange(e)} />
                    <Paragraph className='DesignrequirementsPara' hidden={GatewayNodeQtyvisible} style={{ marginLeft: "10px", fontWeight: '600' }}>{"Minimum Nodes required:1"}</Paragraph>
                  </Box>
                </Box>
                {GatewayserverValue ==="Synergy 480 Gen10 Server" ? <Box>
                  <Paragraph className='DesignrequirementsPara' style={{ margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}>Note: With multi rack solution, single frame Synergy Server is not recommended as Gateway Node.</Paragraph>
                </Box> : " "}
                <Paragraph className='DesignrequirementsPara' style={{ margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}>Note: Additional 1 Gateway Node will be configured if Scality is selected under Storage Function.</Paragraph>
                <Box style={{ display: GatewaySizerdisplay }}>
                  <Paragraph className='DesignrequirementsPara' style={{ margin: "0px", padding: "10px", fontWeight: '600', paddingBottom: '2px' }}>Sizer Recommendation:</Paragraph>
                  <Paragraph className='DesignrequirementsPara' style={{ margin: "0px", paddingLeft: "20px", fontWeight: '600', paddingTop: '0px' }}>{GatewaySizerRecmdtnServer} / {GatewaySizerRecmdtnProcsr} / {GatewaySizerRecmdtnDisktype} / {GatewaySizerRecmdtnMemory} / {GatewaydefaultNodevalue}-Nodes</Paragraph>
                </Box>
              </Box>
            </Tab>


            {/* <Tab title="Edge Node">
        <Box  margin="none" pad="none">               
              <Box direction='row' pad="small" style={{ padding: "10px", overflow: 'auto', width: '95%' }} pad={{ between: 'small' }} >
                <Box style={{ width: '33%' }} pad={{ between: 'small' }}>
                  <FormField className="DiskCapacityDetails" label='Server' error={this.state.DiskCapacityerror}>
                    <Select placeHolder='None' value={EdgeserverValue}options={EdgeServers}  onChange={(e)=>this.onServerChange(e,"Edge Node")} />
                  </FormField>
                  <FormField className="DiskCapacityDetails" label='OS Disk' error={this.state.DiskCapacityerror} >
                    <Select placeHolder='None' value={EdgeosdisktypValue}options={EdgeOSDiskList}  onChange={(e)=>this.onOSDiskChange(e,"Edge Node")}  />
                  </FormField>
                </Box>
                <Box style={{ width: '33%' }} pad={{ between: 'small' }}>
                  <FormField className="DiskCapacityDetails" label='Processor' error={this.state.DiskCapacityerror}>
                    <Select placeHolder='None'  value={EdgeprocessorValue} options={EdgeProcList}  onChange={(e)=>this.onProcessorChange(e,"Edge Node")} />
                  </FormField>
                  <FormField className="DiskCapacityDetails" label='Data Disk' error={this.state.DiskCapacityerror} >
                    <Select placeHolder='None' value={EdgedatadisktypValue} options={EdgeDrives} onChange={(e)=>this.onDataDiskChange(e,"Edge Node")} />
                  </FormField>
                </Box>
                  <Box style={{ width: '33%' }} pad={{ between: 'small' }}>
                    <Box direction="row" pad={{ between: 'small' }}>
                      <FormField className="DiskCapacityDetails" label='Proc Qty'>
                        <Select placeHolder='None' value={EdgepocQtyValue}  onChange={(e)=>this.onProcQtyChange(e,"Edge Node")}/>
                      </FormField>
                    <FormField className="DiskCapacityDetails" label='Memory'>
                        <Select placeHolder='None'  value={EdgememoryValue} options={EdgeMemoryList}  onChange={(e)=>this.onMemoryChange(e,"Edge Node")}/>
                      </FormField>
                      </Box>
                      <Box>
                      <FormField className="DiskCapacityDetails" label='No. of Disks'>
                        <TextInput placeHolder='None'value={EdgenodeDiskQtyvalue}  onDOMChange={(e)=>this.onNoOfDisksChange(e,"Edge Node")}/>
                      </FormField>
                      </Box>
                  </Box>
              </Box>
              <Box direction="row" pad={{ between: 'small' }} style={{ width: '70%',paddingLeft:"9px" }} >
                <FormField className="DiskCapacityDetails" label='Nodes Quantity'style={{ width: '44%' }} >
                    <Select className="NodeSelect" placeHolder='None' value={EdgeNodeQtyValue} options={["1 Per Rack","2 Per Rack"]} onChange={(e)=>this.onNodeQtyChange(e,"Edge Node")}/>
                </FormField>
             </Box>
             <Box>
                  <Paragraph className='DesignrequirementsPara' style={{ margin: "0px",padding:"10px",fontWeight:'600',paddingBottom:'2px'}}>Sizer Recommendation:</Paragraph>
                  <Paragraph className='DesignrequirementsPara' style={{ margin: "0px",paddingLeft:"20px",fontWeight:'600',paddingTop:'0px' }}>{EdgeSizerRecmdtnServer}/{EdgeSizerRecmdtnProcsr}/{EdgeSizerRecmdtnDisktype}/{EdgeSizerRecmdtnMemory}/{EdgedefaultNodevalue}-Nodes</Paragraph>
              </Box>     
         </Box>  
            </Tab>*/}
          </Tabs>
        </Article>
      </Box>

    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSizerWorkload: state.sizerWorkload,
    workload: state.sizerWorkload.workload,
    //    ExtranodeServerDetails:state.sizerWorkload.workload,
    //  //  ExtranodeServerDetails:state.sizerWorkload.serversList.workload.WorkLoad.UserInputs.Environments.ServerDetails,
    //    SupportedComponents:state.sizerWorkload.supportedList,
    //    FilteredComps:state.sizerWorkload.filteredComponents,
    //    ExtranodeRole:state.sizerWorkload.workload,
    //   // ExtranodeRole:state.sizerWorkload.serversList.workload.WorkLoad.UserInputs.Environments.Roles.Role,

    //    UpdatingExtranodesFromServerList:state.sizerWorkload.supportedList,
    //    ActivePartNumbers:state.sizerWorkload.activepartnumbers,
    isLoading: state.sizerWorkload.isLoading,
    activeSession: state.sessions.activeSession

  }
};
const mapDispatchToProps = (dispatch) => {
  return {
    OnDefaultFetchServerList: (value) => {
      dispatch(defaultfetchServerList(value));
    },
    //  getAllFilteredComps : () => {
    //   dispatch(fetchFilteredComps(InputSupportedServers));
    // },
    //  OnFetchSupportedList:() =>{
    //     dispatch(fetchSupportedList());
    //   } ,
    OnGetOSDiskList: (value) => {
      dispatch(getosdisklist(value));
    },
    OnToggleSizeButton: (value) => { dispatch(toggleSizeButton(value)) }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(HadoopServices);



// WEBPACK FOOTER //
// ./src/SizerUI/SizerScreens/ExtraNodesConfiguration.js